import Vue from 'vue'
import Fragment from 'vue-fragment'
import I18n from 'vue-i18n'

import App from './App.vue'

import UiModal from './components/UiModal.vue'

import Configuration from './Configuration.js'
import Profile from './Profile.js'
import Store from './Store.js'
import Queue from './Queue.js'

import locales from './locales'

export const profile = Profile

function getLocale() {
    let locale = document.documentElement.lang || locales.default;
    
    const simDomElems = document.getElementsByTagName('app-simulation');
    if (simDomElems.length > 0 && simDomElems[0].getAttribute("lang")) {
        locale = simDomElems[0].getAttribute("lang")
    }

    return locale;
}

export async function simulation({api, profile, token, /* currency */}) {
    const locationApi = api.replace(/\/doc$/, '/location');

    Vue.use(I18n)
    Vue.use(Fragment.Plugin)
    Vue.use(UiModal)

    Vue.prototype.$config = Configuration
    Vue.prototype.$log = console.log
    Vue.prototype.$queue = new Queue()

    const store = await Store({
        api, locationApi, profile, token,
    })

    const locale = getLocale();
    // Vue.prototype.$currency = !!currency && currency.length ? currency : 'EUR';

    const i18n = new I18n({
        locale: locale,
        fallbackLocale: locales.default,
        messages: Object.assign(locales),
        dateTimeFormats: Object.keys(locales).reduce((formats, key) => {
            formats[key] = locales[key].dates || {}
            return formats
        }, {})
    })

    return new Vue({
        store,
        i18n,
        render: h => h(App),
    }).$mount('app-simulation')
}
